{
  "title": "التصنيفات",
  "description": "تصنيفات البراميل والجراكل المستخدمة في العمليات",
  "columns": {
    "name": "الاسم",
    "type": "النوع",
    "fraction": "القيمة العددية"
  },
  "type": {
    "BARREL": "برميل",
    "JERRYCAN": "جركل"
  },
  "actions": {
    "add": "إضافة تصنيف",
    "delete": "حذف"
  },
  "list": {
    "ariaLabel": "التصنيفات",
    "emptyTitle": "لا توجد بيانات متاحة",
    "emptyAction": "أضف أول تصنيف"
  },
  "drawer": {
    "createTitle": "إضافة تصنيف",
    "fields": {
      "type": "النوع",
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "fraction": "القيمة العددية"
    },
    "submit": "إضافة",
    "cancel": "إلغاء",
    "discard": {
      "title": "تجاهل التغييرات؟",
      "description": "لن يتم حفظ ما أدخلته على هذا التصنيف.",
      "confirmLabel": "تجاهل",
      "cancelLabel": "متابعة التعديل"
    }
  },
  "deleteConfirm": {
    "title": "حذف {{name}}؟",
    "description": "سيتم حذف هذا التصنيف نهائيا. هذا الإجراء لا يمكن التراجع عنه.",
    "confirm": "حذف"
  },
  "toasts": {
    "created": "تم إنشاء التصنيف بنجاح",
    "deleted": "تم حذف التصنيف بنجاح"
  },
  "validation": {
    "mustBePositive": "يجب أن تكون القيمة أكبر من صفر",
    "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى."
  }
}
